module.exports = __webpack_public_path__ + "img/service-233.14c548f7.png";